// libraries.
import { useEffect, useState } from "react";

interface BonusTimerProps {
  validUntil: string;
}

export const BonusTimer = ({ validUntil }: BonusTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const validUntilDate = new Date(validUntil).getTime();
      const difference = validUntilDate - now;

      if (difference <= 0) {
        setIsExpired(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [validUntil]);

  if (isExpired) {
    return (
      <div className="d-flex justify-content-between py-2 mt-2 bonus-card">
        <div className="fw-bold">Bono:</div>
        <div className="text-danger">Bono expirado</div>
      </div>
    );
  }

  const formatTimeUnit = (value: number, unit: string) => {
    return `${value.toString().padStart(2, "0")}${unit}`;
  };

  const timeDisplay = [
    timeLeft.days > 0 && formatTimeUnit(timeLeft.days, "d"),
    formatTimeUnit(timeLeft.hours, "h"),
    formatTimeUnit(timeLeft.minutes, "m"),
    formatTimeUnit(timeLeft.seconds, "s"),
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="d-flex justify-content-between py-2 mt-2 bonus-card">
      <div className="fw-bold">Bono:</div>
      <div className="d-flex flex-column align-items-end">
        <div className="text-warning">
          <small>Expira en {timeDisplay}</small>
        </div>
      </div>
    </div>
  );
};
